/**
 *  Question mixin for all question components
 *
 * Components must implement their own get
 */

export const dataVariableInputMixin = {

    props: {
        variable: {
            type: Object,
            required: true
        },
        value: {
            required: true,
            default: null,
        },
        errorMessages: {
            type: Object,
            required: false,
            default: () => {
                return {};
            }
        }
    },

    data() {
        return {
            model: null,
            modified: false,
            valid: true,
        }
    },

    computed: {

        color() {
            return '#5F5F5F';
        },

        iconColor() {
            return this.variable.panelist_writable ? 'white' : 'grey lighten-1';
        },

        highlightColor() {
           return 'transparent';
        },

        hint() {
            if (this.isMasked) return 'Personally identifiable information has been redacted';
            if (!this.isUserWritable) return 'System variable (non editable)';
        },

        isUserWritable() {
            return this.variable.panelist_writable;
        },

        isDisabled() {
            if (!this.hasPermission('update panelists')) return true;
            if (!this.variable.panelist_writable) return true;
            return !this.hasPermission('view pi') && this.variable.pi;
        },

        isMasked() {
            return !this.hasPermission('view pi') && this.variable.pi;
        },

        icon() {
            return this.$store.state.dataVariableIcons[this.variable.type];
        },

        isDeletable() {
            return !this.variable.answer_required;
        },
    },

    methods: {

        emitDelete(variable) {
            this.$emit('delete', variable);
        },

        emit(value) {
            if (this.variable.uuid) {

                if (!this.$refs.validationObserver) {
                    throw new Error("Validation Observer not found!");
                }

                if (this.valid === false) {

                    // Emit changed values only
                    const action = {
                        valid: false,
                        uuid: this.variable.uuid,
                        value: value,
                        deleted: false,
                    };

                    this.modified = true;

                    this.$emit('input', action);

                } else {

                    this.$refs.validationObserver.validate()
                        .then(isValid => {

                            const action = {
                                valid: isValid,
                                uuid: this.variable.uuid,
                                value: value,
                                deleted: false,
                            };

                            this.modified = true;

                            this.$emit('input', action);
                        });
                }
            }
        },

        cardClicked() {
            this.$emit('click', this.variable);
        },
    },

    mounted() {
        this.model = this.value;
    },
};

